import { RoleActivity } from './RolesForUserList.types';

export const getActivityLabel = (activity: RoleActivity): string => {
  switch (activity) {
    case RoleActivity.active:
      return 'Aktywne';
    case RoleActivity.inActive:
      return 'Nieaktywne';
    case RoleActivity.all:
      return 'Wszystkie';
    default:
      return '???';
  }
};
